import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/index'
import { auth, db } from '@/plugins/appfirebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    user: {
      uid: '',
      username: '',
      photo: '',
      email: '',
    },
    users: [],
    isAuth: false,
    codes: null,
    itemPerPage: 15,

    snackSuccess: false,
    snackDelete: false,
    isError: '',
    isLoginLoading: false

  },
  mutations: {

    setUser(state, payload) {
      state.user = payload;
    },
    setIsAuth(state, payload) {
      state.isAuth = payload;
    },

    setSnackSuccess(state, payload) {
      state.snackSuccess = payload;
    },
    setIsSuccess(state, payload) {
      state.isSuccess = payload;
    },
    setIsError(state, payload) {
      state.isError = payload;
    },
    setIsLoginLoading(state, payload) {
      state.isLoginLoading = payload;
    },

    setCodes(state, payload) {
      state.codes = payload
    },

  },
  actions: {

    // Login user
    userLogin({ commit }, { email, password }) {
      auth
        .signInWithEmailAndPassword(email, password)
        .then( user => {
          commit('setUser', user);
          commit('setIsLoginLoading', false);
          commit('setIsError', '' ); 
          router.push('/admin');
        })
        .catch( err => { 
          commit('setIsError', err ); 
          commit('setIsLoginLoading', false);
        });
    },

    // Logout user
    userSignOut({ commit }) {
      auth
        .signOut()
        .then(() => { router.push('/login'); })
        .catch( err => { commit('setIsError', err ); });
    },

    // New Email Record
    storeEmail({ commit }, { counter, fullname, email, password, usefor, phone, remark } ) {

      var record = { id: (counter+1).toString(), fullname, email, password, usefor, phone, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('email').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New Facebook Record
    storeFacebook({ commit }, { counter, profile, email, password, usefor, phone, status, remark } ) {

      var record = { id: (counter+1).toString(), profile, email, password, usefor, phone, status, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('facebook').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New GoDaddy Record
    storeGodaddy({ commit }, { counter, fullname, login_id, email, password, domain_name, remark } ) {

      var record = { id: (counter+1).toString(), fullname, login_id, email, password, domain_name, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('godaddy').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New Paypal Record
    storePaypal({ commit }, { counter, fullname, login_id, email, password, phone, card_holder, card_number, remark } ) {

      var record = { id: (counter+1).toString(), fullname, login_id, email, password, phone, card_holder, card_number, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('paypal').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New Paypal Record
    storeVcard({ commit }, { counter, card_holder, card_number, cvv, expire_date, app_code, phone, remark } ) {

      var record = { id: (counter+1).toString(), card_holder, card_number, cvv, expire_date, app_code, phone, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('vcard').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New Website Record
    storeWebsite({ commit }, { counter, company, domain, username, password, user_level, take_from, contact, position_sharing, remark } ) {

      var record = { id: (counter+1).toString(), company, domain, username, password, user_level, take_from, contact, position_sharing, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('website').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // New Apple Record
    storeApple({ commit }, { counter, name, apple_id, password, phone, country, remark } ) {

      var record = { id: (counter+1).toString(), name, apple_id, password, phone, country, remark, lock: true, uid: auth.currentUser.uid, timestamp: Date.now() };

      db.collection('apple').doc(auth.currentUser.uid).collection('data').doc((counter+1).toString()).set(record)
      .then( () => { commit('setSnackSuccess', true); })
      .catch( err => { commit('setIsError', err ) });

    },

    // secret codes
    requestCodes({commit}) {
        db.collection('codes').doc('secret')
            .get()
            .then( doc => {
                commit('setCodes', doc.data())
            })
            .catch( err => { commit('setIsError', err ) })
    },

  },
  modules: {
  }
})
